import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /f?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fasting_f_welcome_topic~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_fasting_f_welcome_topic'),
			},
		},
	},
]

export default config
